import React from 'react';

import { SearchParams, useSearchParam } from '@/domain/app';

import { KbCardDetails, TeCardDetails } from './components';

import './CardDetailsPage.scss';

export const CardDetailsPage = () => {
    const ctype = useSearchParam(SearchParams.CARD_TYPE);

    if (ctype === 'CREDIT') {
        return <KbCardDetails />;
    }

    return <TeCardDetails />;
};
